module.exports = __webpack_public_path__ + "img/logo.f31be513.png";